<template>
  <div
    class="image-container"
    :class="[
      expandContent ? 'expand-content' : '',
      isEmpty ? 'empty-data' : '',
    ]"
  >
    <div class="image-item" v-for="(item, index) in data" :key="index">
      <span class="default-icon" v-if="item.isDefault === 'Y'">
        <i class="el-icon-success"></i>
      </span>
      <el-image
        style="width: 100%; height: 100%"
        fit="cover"
        :src="item.displayImageUrl"
      ></el-image>
      <div class="shadow d-flex align-items-center justify-content-center">
        <div>
          <span @click="onImagePreview({ ...item, index })">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            @click="onImageCheck({ ...item, index })"
            class="ml-2"
            v-if="item.isDefault === 'N'"
          >
            <i class="el-icon-check"></i>
          </span>
          <span @click="onImageDel({ ...item, index })" class="ml-2">
            <i class="el-icon-delete-solid"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="empty-data" v-if="isEmpty">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data mt-4">
        {{ '请点击上传图片按钮' }}
      </p>
    </div>
    <div v-show="false" class="imagesViewer" v-viewer="{ movable: true }">
      <img
        v-for="(item, index) in previewSrcs"
        :src="item || '/image/static/img/nopic.jpg'"
        :key="index"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
    expandContent: { type: Boolean, default: false },
  },
  data() {
    return {
      viewer: null,
    }
  },
  computed: {
    previewSrcs() {
      if (!this.data || !this.data.length) return []
      return this.data.map((item) => item.originImageUrl)
    },
    isEmpty() {
      return !this.data || !this.data.length
    },
  },
  methods: {
    onImagePreview({ index }) {
      if (!this.previewSrcs || !this.previewSrcs.length) return
      this.viewer = this.$el.querySelector('.imagesViewer').$viewer
      this.viewer.view(index)
      this.viewer.show()
    },
    onImageCheck(e) {
      this.$emit('imageCheck', e)
    },
    onImageDel(e) {
      this.$emit('imageDel', e)
    },
  },
}
</script>
<style lang="scss" scoped>
.image-container {
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  padding: 0 10px;
}
.image-container.expand-content {
  overflow: initial;
  flex-wrap: wrap;
  display: flex;
}
.image-container.expand-content.empty-data {
  height: calc(100% - 66px);
  align-items: center;
  justify-content: center;
}

.empty-data {
  text-align: center;
  margin: 10px auto;
}

.image-item {
  width: 160px;
  height: 160px;
  line-height: 160px;
  position: relative;
  background-color: #fbfdff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  margin: 8px;
  flex-shrink: 0;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}

.image-item:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
</style>
